import { FC, useEffect, useState, ReactNode } from 'react';
import Bottomsheet from '@ixigo/iui/Bottomsheet';
import BottomsheetHeader from '../../BottomsheetHeader';

interface BaseDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
    children: ReactNode;
}

const BaseDetailsModal: FC<BaseDetailsModalProps> = ({ isOpen, onClose, title, subtitle, children }) => {
    const [visible, setVisible] = useState(isOpen);

    useEffect(() => {
        if (isOpen) {
            setVisible(true);
        }
    }, [isOpen]);

    const handleClose = () => {
        setVisible(false);
        // Wait for animation to complete before calling onClose
        setTimeout(() => {
            onClose();
        }, 300); // Match the transition duration
    };

    return (
        <Bottomsheet open={visible} onClose={handleClose} classes={{ container: '!min-w-full !max-h-[80vh]' }}>
            <div className='flex flex-col bg-white rounded-t-[10px] overflow-hidden w-full'>
                <BottomsheetHeader
                    title={title}
                    subtitle={subtitle}
                    onClose={handleClose}
                    className='flex flex-col items-center pt-15 pb-15 bg-transparent relative border-none'
                />

                <div className='border-b border-gray-200' />

                <div className='px-20 py-20'>{children}</div>
            </div>
        </Bottomsheet>
    );
};

export default BaseDetailsModal;
